<template>
  <div id="consumption" class="form" :class="$mq">
    <h3>{{ $t("step2.title") }}</h3>

    <ValidationObserver ref="observer" v-slot="{ valid }" slim>
      <MeterType v-if="hasElec"></MeterType>

      <KnowConsumption></KnowConsumption>

      <div class="button inline">
        <button @click="nextStep()" class="stroke">{{ $t('continue') }}</button>
      </div>
    </ValidationObserver>
    <div class="loader" v-if="loading">
      <SvgIcon class="icon" icon="loader"></SvgIcon>
    </div>
  </div>
</template>

<script>
import MeterType from "./consumption/MeterType";
import KnowConsumption from "./consumption/KnowConsumption/";
import { mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapState("energy", ["type"]),
    ...mapState("consumption", ["meterType"]),
    ...mapGetters("energy", ["hasElec", "hasGas"])
  },
  methods: {
    nextStep: async function() {
      let isValid = await this.$refs.observer.validate();

      if (isValid) {
        try {
          this.loading = true;
          await this.$store.dispatch("consumption/getConsumption");
          this.$store.commit("consumption/setValid", true);
          this.$store.dispatch("consumption/save");
          this.loading = false;

          this.$router.push({ name: "Calculation", query: this.$route.query });
        } catch (error) {
          console.log(error);
        }
      }
    }
  },
  watch: {
    type: {
      immediate: true,
      handler(val) {
        let meterTypes = this.$store.state.consumption.meterType;

        switch (val) {
          case "elec":
            meterTypes = meterTypes.filter(meterTypes => meterTypes !== "gas");
            if (meterTypes.includes("mono")) meterTypes = ["mono"];
            if (!meterTypes.length) {
              meterTypes = ["day", "night"];
            }

            break;
          case "gas":
            meterTypes = meterTypes.filter(meterTypes => meterTypes === "gas");
            if (!meterTypes.length) {
              meterTypes = ["gas"];
            }

            break;
          case "both":
            let elecMeterTypes = meterTypes.filter(
              meterTypes => meterTypes !== "gas"
            );
            if (!elecMeterTypes.length) elecMeterTypes = ["day", "night"];
            let gasMeterTypes = meterTypes.filter(
              meterTypes => meterTypes === "gas"
            );
            if (!gasMeterTypes.length) gasMeterTypes = ["gas"];

            meterTypes = elecMeterTypes.concat(gasMeterTypes);
            break;
        }

        this.$store.commit("consumption/setMeterType", meterTypes);
      }
    }
  },
  created() {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: "simulation-step2-consumption",
      "cookie-acceptation": "true"
    });
    window.scrollTo(0, 0);
  },
  components: {
    MeterType,
    KnowConsumption
  }
};
</script>


// WEBPACK FOOTER //
// src/views/Consumption.vue